<footer class="bg-primary">
  <div
    class="container py-5"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
    data-aos-duration="1000"
    data-aos-delay="200"
  >
    <div class="d-flex flex-wrap align-items-center justify-content-between">
      <div class="mb-2">
        <div class="mb-3">
          <a href="#">
            <img src="assets/img/efb_white.svg" width="200" class="img-fluid" alt="logofooter" />
          </a>
        </div>
        <p class="text-opacity-75 text-white">{{ "RIGHTS" | translate }} {{ currentYear }}</p>
      </div>
      <!-- <div class="mb-3">
                <h5 class="text-white mb-3">{{ 'SUBSCRIBE' | translate }}</h5>
                <form class="row g-2">
                  <div class="col-auto">
                    <label for="newsletter"  class="visually-hidden">{{ 'EMAIL' | translate }}</label>
                    <input type="email" disabled class="form-control" id="newsletter" placeholder="Votre Adresse mail ">
                  </div>
                  <div class="col-auto">
                    <button  disabled type="submit" class="btn btn-light mb-3"><i class="bi-arrow-right"></i></button>
                  </div>
                </form>
            </div> -->
      <div class="d-flex flex-column gap-3">
        <div class="d-flex align-items-center justify-content-sm-end">
          <h6 class="text-white mb-0 me-3">{{ "FOLLOWING" | translate }}</h6>
          <div class="d-flex align-items-center mb-0 me-3">
            <a href="#" class="text-white me-3 fs-4" aria-label="Facebook"
              ><i class="bi-facebook"></i
            ></a>
            <a href="#" class="text-white me-3 fs-4" aria-label="LinkedIn"
              ><i class="bi-linkedin"></i
            ></a>
            <a href="#" class="text-white fs-4" aria-label="Instagram"
              ><i class="bi-instagram"></i
            ></a>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-sm-end">
          <h6 class="text-white mb-0 me-3">{{ mailprofessionel }}</h6>
          <h6 class="text-white mb-0 me-3">0029 01 96 00 00 00</h6>
        </div>
        <div class="d-flex align-items-center justify-content-sm-end">
          <h6 class="text-white mb-0 me-3">
            <a href="#" class="style_link">{{ "POLITIC" | translate }}</a>
          </h6>
          <h6 class="text-white mb-0 me-3">
            <a href="#" class="style_link">{{ "MENTIONS" | translate }}</a>
          </h6>
        </div>
      </div>
    </div>
  </div>
</footer>
